// 変換計画に使う動画のメタデータを読む（デコードはしない）
import { Input, ALL_FORMATS, BlobSource } from 'mediabunny';
import { OptimizeError } from './videoOptimize';

/**
 * @returns {Promise<{ width, height, squareWidth, squareHeight, rotation, frameRate, duration }>} 寸法は回転前
 */
export const readVideoMeta = async (file) => {
    const input = new Input({ source: new BlobSource(file), formats: ALL_FORMATS });
    try {
        const track = await input.getPrimaryVideoTrack();
        if (!track) throw new OptimizeError('no_video');
        if (await track.hasHighDynamicRange()) throw new OptimizeError('hdr');
        const [width, height, squareWidth, squareHeight, rotation, stats, start, end] = await Promise.all([
            track.getCodedWidth(), track.getCodedHeight(), track.getSquarePixelWidth(), track.getSquarePixelHeight(),
            track.getRotation(), track.computePacketStats(), track.getFirstTimestamp(), track.computeDuration(),
        ]);
        return { width, height, squareWidth, squareHeight, rotation, frameRate: stats.averagePacketRate, duration: Math.max(0, end - start) };
    } catch (e) {
        if (e instanceof OptimizeError) throw e;
        throw new OptimizeError('failed', String((e && e.message) || e));
    } finally {
        input.dispose();
    }
};
